<template>
  <div>
    <a-gantt-elastic v-if="false" ref="gantt" :url="url" :object_id="id" :config="{ height: gantHeight, taskList: switchGant }" />
    <gantt-elastic v-if="!loading" :tasks="tasks" :options="options">
      <gantt-header v-if="0" slot="header"></gantt-header>
    </gantt-elastic>
    <div v-if="loading" class="loading-block">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
import GanttElastic from "gantt-elastic";
import GanttHeader from "gantt-elastic-header";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { getAccess, validate, genModel, modelOptions } from "@/components/mixings";
import dayjs from "dayjs";
export default {
  mixins: [getAccess, validate, genModel, modelOptions],
  components: { GanttElastic, GanttHeader },
  props: {
    object_id: Number,
    object_data: Object,
    config: { type: Object, default: {} },
  },
  data() {
    return {
      url: "/mechti/construction-schedule",
      tasks: {},
      data: [],
      loading: true,
    };
  },
  created() {
    this.fitchData();
    console.log("height", this.options.height);
    if (this.config?.height) this.options.maxHeight = this.config.height - 82;
    if (this.config?.taskList) this.options.taskList.display = false;
  },
  computed: {
    options() {
      return {
        calendar: {
          hour: { display: false },
        },
        maxHeight1: 400,
        allVisibleTasksHeight: 400,
        title: {
          label: "Your project title as html (link or whatever...)",
          //html: false,
        },
        times: { timeScale: 60 * 1000, timeZoom: 21 },
        scope: { before: 1, after: 15 },
        chart: {
          text: { offset: 4, xPadding: 20, display: true },
        },
        taskList: {
          columns: [
            { id: 1, label: "ID", value: "id", width: 40 },
            { id: 2, label: "Описание задачи", value: "label", width: 200, expander: true },
            //{ id: 3, label: 'Назначена для', value: 'user', width: 130, html: true },
            { id: 3, label: "Дата начала", value: task => dayjs(task.start).format("DD.MM.YYYY"), width: 78 },
            { id: 4, label: "Тип", value: "department", width: 68 },
            // { id: 5, label: '%', value: 'progress', width: 35, style: { 'task-list-header-label': { 'text-align': 'center', width: '100%' }, 'task-list-item-value-container': { 'text-align': 'center' } } },
          ],
        },
        locale: {
          name: "ru", // name String
          weekdays: "Воскресенье,Понедельник,Вторник,Среда,Четверг,Пятница,Суббота".split(","), // weekdays Array
          weekdaysShort: "ПН,ВТ,СР,ЧТ,ПТ,СБ,ВС".split(","), // OPTIONAL, short weekdays Array, use first three letters if not provided
          months: "Январь_Фераль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь".split("_"),
        },
      };
    },
    defaults() {
      let res = {
        sort: [
          { key: "date_start", order: "ASC" },
          { key: "id", order: "ASC" },
        ],
        filters: { object_id: this.id },
        paramName: "work",
      };
      return res;
    },

    id() {
      return Number(this.$route.params.id);
    },
  },
  watch: {
    "config.taskList"(v) {
      console.log("watch config.taskList", this.config.taskList);
      this.options.taskList.display = this.config.taskList;
    },
  },
  methods: {
    async doExport() {
      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet("Gantt Chart");
      const ganttData = this.data;

      // Определим диапазон дат
      const minDate = new Date(Math.min(...ganttData.map(t => new Date(t.date_start))));
      const maxDate = new Date(Math.max(...ganttData.map(t => new Date(t.date_end))));
      const allDates = [];
      const daysCount = Math.round((maxDate - minDate) / 86400000) + 1;

      // Создаём массив всех дат между minDate и maxDate
      for (let i = 0; i < daysCount; i++) {
        const d = new Date(minDate);
        d.setDate(d.getDate() + i);
        allDates.push(d);
      }

      // Выбираем даты для заголовка с учетом длинных пробелов
      const headerDates = [];
      let gapStart = null;
      for (let i = 0; i < allDates.length; i++) {
        const d = allDates[i];
        const hasTask = ganttData.some(t => {
          const start = new Date(t.date_start);
          const end = new Date(t.date_end);
          return d >= start && d <= end;
        });

        if (hasTask) {
          // Любая дата с задачей идёт в заголовок
          headerDates.push({ date: d, color: null });
          gapStart = null; // закрываем пробел
        } else {
          // Дата без задачи
          if (!gapStart) gapStart = i; // начало нового пробела

          // если конец пробела или последняя дата
          const isEnd =
            i === allDates.length - 1 ||
            ganttData.some(t => {
              const start = new Date(t.date_start);
              const end = new Date(t.date_end);
              return allDates[i + 1] >= start && allDates[i + 1] <= end;
            });

          if (isEnd) {
            const gapLength = i - gapStart + 1;
            if (gapLength > 3) {
              // оставляем только первый и последний день пробела
              headerDates.push({ date: allDates[gapStart], color: "FFFF0000" }); // красный
              headerDates.push({ date: allDates[i], color: "FFFF0000" });
            } else {
              // все даты маленького пробела добавляем обычными
              for (let j = gapStart; j <= i; j++) {
                headerDates.push({ date: allDates[j], color: null });
              }
            }
            gapStart = null;
          }
        }
      }

      // Формируем заголовок Excel
      const headerRowValues = ["Task", ...headerDates.map(h => h.date)];
      const excelHeader = ws.addRow(headerRowValues);

      // Вертикальный текст и окраска пробелов
      excelHeader.eachCell((cell, colNumber) => {
        if (colNumber === 1) {
          ws.getColumn(colNumber).width = 20;
        } else {
          cell.alignment = { textRotation: 90, vertical: "middle", horizontal: "center" };
          ws.getColumn(colNumber).width = 3;

          const color = headerDates[colNumber - 2].color;
          if (color) {
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: color } };
          }
        }
      });

      // Строим строки задач
      ganttData.forEach(task => {
        const start = new Date(task.date_start);
        const end = new Date(task.date_end);
        const rowValues = [task.name];

        headerDates.forEach(h => {
          rowValues.push(h.date >= start && h.date <= end ? "■" : "");
        });

        ws.addRow(rowValues);

        // закрашиваем ячейки задач
        const excelRow = ws.lastRow;
        excelRow.eachCell((cell, colNumber) => {
          if (colNumber > 1 && cell.value === "■") {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FF00B0F0" }, // голубой
            };
          }
        });
      });

      // Сохраняем
      const buf = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buf]), `График работ (${this?.object_data?.name || this.object_id}).xlsx`);
    },

    mapTasks(tasks) {
      return tasks.map(task => {
        return {
          id: task.id,
          label: task.name,
          //     user: task.user,
          start: new Date(task.date_start).date,
          end: new Date(task.date_end).setHours(23),
          //  progress: task.progress,
          progress: 5,
          type: "task", // task.department,
          department: task.department,
          style: {},
          //  style: taskStyles[task.type],
          //  parentId: task.parent_id,
          //  dependentOn: task.dependencies,
        };
      });
    },
    async fitchData() {
      this.loading = true;
      const d = await this.$axios.get(this.url, {
        params: {
          filters: { object_id: this.object_id },
          sort: { key: "date_start", order: "ASC" },
        },
      });
      if (d.data && d.data.data) {
        this.data = d.data.data;
        this.tasks = this.mapTasks(this.data);
      }
      this.loading = false;
    },
  },
};
</script>
